import * as AUTH_ACTION from 'js/constant/action/auth'
import { handleActions } from 'redux-actions'

const initialState = {
  isAuthenticated: false,
  userDetails: null,
  verification: false,
  openMobileSidebar: false
}

export default handleActions(
  {
    [AUTH_ACTION.UPDATE_IS_AUTHENTICATED]: (state, action) => ({
      ...state,
      isAuthenticated: action.payload
    }),
    [AUTH_ACTION.UPDATE_USER_DETAILS]: (state, action) => ({
      ...state,
      userDetails: action.payload
    }),
    [AUTH_ACTION.UPDATE_VERTIFICATION]: (state, action) => ({
      ...state,
      verification: action.payload
    }),
    [AUTH_ACTION.OPEN_MOBILE_SIDEBAR]: (state, action) => ({
      ...state,
      openMobileSidebar: action.payload
    })
  },
  initialState
)
